
/* !!! This is code generated by Prisma. Do not edit directly. !!!
/* eslint-disable */

Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.11.0
 * Query Engine version: 9c30299f5a0ea26a96790e13f796dc6094db3173
 */
Prisma.prismaVersion = {
  client: "6.11.0",
  engine: "9c30299f5a0ea26a96790e13f796dc6094db3173"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  emailVerified: 'emailVerified',
  image: 'image',
  role: 'role',
  banned: 'banned',
  banReason: 'banReason',
  banExpires: 'banExpires',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  token: 'token',
  expiresAt: 'expiresAt',
  ipAddress: 'ipAddress',
  userAgent: 'userAgent',
  impersonatedBy: 'impersonatedBy',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId'
};

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  providerId: 'providerId',
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  idToken: 'idToken',
  accessTokenExpiresAt: 'accessTokenExpiresAt',
  refreshTokenExpiresAt: 'refreshTokenExpiresAt',
  scope: 'scope',
  password: 'password',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId'
};

exports.Prisma.VerificationScalarFieldEnum = {
  id: 'id',
  identifier: 'identifier',
  value: 'value',
  expiresAt: 'expiresAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AdScalarFieldEnum = {
  id: 'id',
  email: 'email',
  name: 'name',
  description: 'description',
  websiteUrl: 'websiteUrl',
  buttonLabel: 'buttonLabel',
  faviconUrl: 'faviconUrl',
  type: 'type',
  startsAt: 'startsAt',
  endsAt: 'endsAt',
  sessionId: 'sessionId',
  subscriptionId: 'subscriptionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ToolScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  websiteUrl: 'websiteUrl',
  affiliateUrl: 'affiliateUrl',
  repositoryUrl: 'repositoryUrl',
  tagline: 'tagline',
  description: 'description',
  content: 'content',
  stars: 'stars',
  forks: 'forks',
  score: 'score',
  faviconUrl: 'faviconUrl',
  screenshotUrl: 'screenshotUrl',
  isFeatured: 'isFeatured',
  isSelfHosted: 'isSelfHosted',
  submitterName: 'submitterName',
  submitterEmail: 'submitterEmail',
  submitterNote: 'submitterNote',
  discountCode: 'discountCode',
  discountAmount: 'discountAmount',
  firstCommitDate: 'firstCommitDate',
  lastCommitDate: 'lastCommitDate',
  pageviews: 'pageviews',
  status: 'status',
  publishedAt: 'publishedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  licenseId: 'licenseId',
  ownerId: 'ownerId'
};

exports.Prisma.CampaignScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  websiteUrl: 'websiteUrl',
  affiliateUrl: 'affiliateUrl',
  repositoryUrl: 'repositoryUrl',
  tagline: 'tagline',
  description: 'description',
  content: 'content',
  stars: 'stars',
  forks: 'forks',
  score: 'score',
  faviconUrl: 'faviconUrl',
  screenshotUrl: 'screenshotUrl',
  isFeatured: 'isFeatured',
  isSelfHosted: 'isSelfHosted',
  submitterName: 'submitterName',
  submitterEmail: 'submitterEmail',
  submitterNote: 'submitterNote',
  discountCode: 'discountCode',
  discountAmount: 'discountAmount',
  firstCommitDate: 'firstCommitDate',
  lastCommitDate: 'lastCommitDate',
  pageviews: 'pageviews',
  status: 'status',
  publishedAt: 'publishedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  licenseId: 'licenseId',
  ownerId: 'ownerId'
};

exports.Prisma.StoreScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  websiteUrl: 'websiteUrl',
  affiliateUrl: 'affiliateUrl',
  instagramUrl: 'instagramUrl',
  description: 'description',
  content: 'content',
  email: 'email',
  phone: 'phone',
  address: 'address',
  isIverified: 'isIverified',
  igFollowers: 'igFollowers',
  tkFollowers: 'tkFollowers',
  ytFollowers: 'ytFollowers',
  score: 'score',
  faviconUrl: 'faviconUrl',
  screenshotUrl: 'screenshotUrl',
  isFeatured: 'isFeatured',
  isBrand: 'isBrand',
  pageviews: 'pageviews',
  status: 'status',
  publishedAt: 'publishedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  licenseId: 'licenseId',
  ownerId: 'ownerId',
  locationId: 'locationId'
};

exports.Prisma.ProfileScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  description: 'description',
  websiteUrl: 'websiteUrl',
  faviconUrl: 'faviconUrl',
  discountCode: 'discountCode',
  discountAmount: 'discountAmount',
  pageviews: 'pageviews',
  adPrice: 'adPrice',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  adId: 'adId'
};

exports.Prisma.CategoryScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  fullPath: 'fullPath',
  label: 'label',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  parentId: 'parentId'
};

exports.Prisma.TopicScalarFieldEnum = {
  slug: 'slug',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.LicenseScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.StackScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  type: 'type',
  description: 'description',
  website: 'website',
  faviconUrl: 'faviconUrl',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.LocationScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  country: 'country',
  description: 'description',
  website: 'website',
  faviconUrl: 'faviconUrl',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ReportScalarFieldEnum = {
  id: 'id',
  type: 'type',
  message: 'message',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  toolId: 'toolId',
  campaignId: 'campaignId',
  storeId: 'storeId'
};

exports.Prisma.LikeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  userId: 'userId',
  toolId: 'toolId',
  campaignId: 'campaignId',
  storeId: 'storeId'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};
exports.AdType = exports.$Enums.AdType = {
  Banner: 'Banner',
  Profiles: 'Profiles',
  ProfilePage: 'ProfilePage',
  Tools: 'Tools',
  ToolPage: 'ToolPage',
  SelfHosted: 'SelfHosted',
  BlogPost: 'BlogPost',
  All: 'All',
  Campaigns: 'Campaigns',
  Stores: 'Stores'
};

exports.ToolStatus = exports.$Enums.ToolStatus = {
  Draft: 'Draft',
  Scheduled: 'Scheduled',
  Published: 'Published'
};

exports.CampaignStatus = exports.$Enums.CampaignStatus = {
  Draft: 'Draft',
  Scheduled: 'Scheduled',
  Published: 'Published'
};

exports.StoreStatus = exports.$Enums.StoreStatus = {
  Draft: 'Draft',
  Scheduled: 'Scheduled',
  Published: 'Published'
};

exports.StackType = exports.$Enums.StackType = {
  Tool: 'Tool',
  SaaS: 'SaaS',
  Cloud: 'Cloud',
  ETL: 'ETL',
  Analytics: 'Analytics',
  Language: 'Language',
  DB: 'DB',
  CI: 'CI',
  Framework: 'Framework',
  Hosting: 'Hosting',
  API: 'API',
  Storage: 'Storage',
  Monitoring: 'Monitoring',
  Messaging: 'Messaging',
  App: 'App',
  Network: 'Network'
};

exports.ReportType = exports.$Enums.ReportType = {
  BrokenLink: 'BrokenLink',
  WrongCategory: 'WrongCategory',
  WrongProfile: 'WrongProfile',
  Outdated: 'Outdated',
  Other: 'Other'
};

exports.Prisma.ModelName = {
  User: 'User',
  Session: 'Session',
  Account: 'Account',
  Verification: 'Verification',
  Ad: 'Ad',
  Tool: 'Tool',
  Campaign: 'Campaign',
  Store: 'Store',
  Profile: 'Profile',
  Category: 'Category',
  Topic: 'Topic',
  License: 'License',
  Stack: 'Stack',
  Location: 'Location',
  Report: 'Report',
  Like: 'Like'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }

        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
